<template>
  <fts-client-modal
    :append-to-body="appendToBody"
    :width="'90%'"
    dynamic-screen
    :footer="false"
    title="Story"
    ref="traceModal"
  >
    <!-- body -->
    <template #body>
      <div v-if="response && response.data">
        <div>
          <h2>{{ response.data.workspace }}</h2>
        </div>

        <div v-if="response.data.request.traces.some((x) => x)">
          On
          {{ moment(response.data.request.traces[0].start).format("LLLL") }} by
          {{ response.data.request.traces[0].by }}
        </div>

        <div v-for="item in response.data.request.traces" :key="item.id">
          <AutomationRunTrace
            :history-id="historyId"
            :run="item"
          ></AutomationRunTrace>
        </div>
      </div>
    </template>
  </fts-client-modal>
</template>
  
<script>
import moment from "moment";
import { clientStore } from "../../store/clientStore";

import FTSClientModal from "../../elements/FTSClientModal";
import AutomationRunTrace from "../../admin/automationRunTrace";

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    AutomationRunTrace
  },
  props: {
    appendToBody: Boolean,
    requestId: String,
    historyId: String,
  },
  data: () => ({
    resolve: null,
    response: {}
  }),
  methods: {
    moment,
    async show() {
      try {
        this.response = await clientStore.dispatch("trace", this.requestId);
        return new Promise((resolve) => {
          this.resolve = resolve;
          this.$refs.traceModal.show();
        });
      } catch (err) {
        this.$toasted.global.error(err);
      }
    }
  }
};
</script>